"use strict";

var React = require("react");

var SvgIconMenuV2 = function SvgIconMenuV2() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 10",
    },
    /*#__PURE__*/ React.createElement(
      "g",
      {
        fill: "none",
        fillRule: "evenodd",
      },
      /*#__PURE__*/ React.createElement("path", {
        d: "M-2-5h20v20H-2z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d:
          "M.5 10h15V8.333H.5V10zm0-4.167h15V4.167H.5v1.666zM.5 0v1.667h15V0H.5z",
        fill: "currentColor",
      })
    )
  );
};

exports["foreignIcon"] = SvgIconMenuV2;
